import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "disabledchannel-16-px_434c7414cb2ad5efde258956ee373f93",
  "use": "disabledchannel-16-px_434c7414cb2ad5efde258956ee373f93-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"disabledchannel-16-px_434c7414cb2ad5efde258956ee373f93\">\n    <path fill-rule=\"evenodd\" d=\"M10.957 4L12 5.043 9.043 8 12 10.957 10.957 12 8 9.043 5.043 12 4 10.957 6.957 8 4 5.043 5.043 4 8 6.957z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol